<script>
import { loadKeiyoUserSetting, saveAdminUserInfo } from '@/api/data'
import { getI18nLanguage } from '@/locales'

export default {
  name: 'UserProfile',
  props: ['uid', 'layerid', 'editable'],
  data () {
    return {
      form: this.$form.createForm(this),
      isCN: getI18nLanguage() === 'zh-CN',
      loading: false
    }
  },
  created () {
    if (this.editable === undefined) {
      this.editable = false
    }
    this.$nextTick(function () {
      loadKeiyoUserSetting({ uid: this.uid }).then(res => {
         if (res.code === 0) {
           this.form.setFieldsValue(res.data)
         }
      })
    })
  },
  methods: {
    getErrorMessage (msg) {
      if (typeof msg === 'string') {
        return msg
      }
      const lang = this.$i18n.locale || 'en-US'
      const langKey = lang.replace('-', '').toLowerCase()
      const enKey = 'en'
      const zhKey = 'zh'
      const jaKey = 'ja'

      if (langKey.includes('zh')) {
        return msg[zhKey] || msg['zh-CN'] || msg['en'] || msg['en-US'] || ''
      } else if (langKey.includes('ja')) {
        return msg[jaKey] || msg['ja-JP'] || msg['en'] || msg['en-US'] || ''
      } else {
        return msg[enKey] || msg['en-US'] || msg['en'] || ''
      }
    },
    submitForm () {
      if (!this.editable) {
        return
      }

      const { form: { validateFields } } = this

      validateFields((err, values) => {
        if (!err) {
          this.loading = true

          const params = {
            info: JSON.stringify(values),
            uid: this.uid
          }

          saveAdminUserInfo(params)
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('user.action.save.success'))
                this.$layer.close(this.layerid)
              } else {
                this.$message.error(this.getErrorMessage(res.msg) || this.$t('user.action.save.fail'))
              }
            })
            .catch(() => {
              this.$message.error(this.$t('user.action.save.fail'))
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px;">
    <a-row>
      <a-col :span="8" v-if="!isCN">
        <img src="/images/carsn.jpg" style="width: 100%;"/>
      </a-col>
      <a-col :span="16" :offset="isCN?4:0">
        <a-form :form="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
          <a-form-item :label="$t('user.name')">
            <a-input
              :disabled="!editable"
              v-decorator="['name', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item label="ID">
            <a-input
              :disabled="!editable"
              v-decorator="['id', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item :label="$t('user.car.area')" v-if="!isCN">
            <a-input
              :disabled="!editable"
              v-decorator="['area', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item :label="$t('user.car.type')" v-if="!isCN">
            <a-input
              :disabled="!editable"
              v-decorator="['type', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item :label="$t('user.car.plateName')" v-if="!isCN">
            <a-input
              :disabled="!editable"
              v-decorator="['plateName', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item :label="$t('user.car.number')" v-if="!isCN">
            <a-input
              :disabled="!editable"
              v-decorator="['number', { rules: [{ required: false, message: '' }] }]"
            />
          </a-form-item>
          <a-form-item :label="$t('user.car.color')" v-if="!isCN">
            <a-select
              :disabled="!editable"
              v-decorator="[
                'color',
                { rules: [{ required: false, message: '' }] },
              ]"
            >
              <a-select-option value="white_green">
                {{ $t('user.car.color.GreenWhite') }}
              </a-select-option>
              <a-select-option value="green_white">
                {{ $t('user.car.color.WhiteGreen') }}
              </a-select-option>
              <a-select-option value="yellow_black">
                {{ $t('user.car.color.BlackYellow') }}
              </a-select-option>
              <a-select-option value="black_yellow">
                {{ $t('user.car.color.YellowBlack') }}
              </a-select-option>
              <a-select-option value="blue_green">
                {{ $t('user.car.color.GreenBlue') }}
              </a-select-option>
              <a-select-option value="white_red">
                {{ $t('user.car.color.RedWhite') }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item :wrapperCol="{ span: 12,offset: 8 }">
            <a-button
              type="primary"
              :disabled="!editable"
              :loading="loading"
              @click="submitForm"
            >
              {{ $t('user.action.save') }}
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<style scoped lang='less'>

</style>
